import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FacebookShareButton, FacebookIcon, TwitterShareButton, XIcon, LinkedinShareButton, LinkedinIcon, PinterestShareButton, PinterestIcon} from 'react-share';
import styles from './RecordPopup.module.css';
import { generateQuery } from '../CC/utils';
import { ccConfig, CC } from '../CC/CC';
import { CCProvider, useCCContext } from '../CC/CCContext';
import Record from '../Record/Record';
import GenericIconButton from '../GenericComponents/GenericIconButton';
import * as ccUtils from '../CC/utils';
import genericStyles from '../GenericComponents/GenericStyles.module.css';
declare var html3pdf: any;

interface RecordPopupProps {
  recordNumber: number;
  onClose: () => void;
}

function copyCanvasContent(sourceCanvas: HTMLCanvasElement, targetCanvas: HTMLCanvasElement) {
  const ctx = targetCanvas.getContext('2d');
  ctx?.drawImage(sourceCanvas, 0, 0);
}

const generatePdf = (objectNumber:string) => {

  if (window.osdViewer) {
    window.osdViewer.viewport.goHome();
  }
  setTimeout(() => {
    // Step 1: Create a deep clone of the original element.
    const originalElement = document.getElementById("pdf-container") as HTMLElement;
    const clonedElement = originalElement.cloneNode(true) as HTMLElement;
    const objectNumberElement = document.getElementById("objectnumber") as HTMLElement;

    // Copy canvas contents
    const originalCanvases = originalElement.querySelectorAll('canvas');
    const clonedCanvases = clonedElement.querySelectorAll('canvas');

    originalCanvases.forEach((canvas, index) => {
      copyCanvasContent(canvas, clonedCanvases[index] as HTMLCanvasElement);
    });

    clonedElement.style.top = '-10000px'; // move it far off-screen
    clonedElement.style.display = 'block'; // keep it hidden
    document.body.appendChild(clonedElement);

    setTimeout(() => {
      if (objectNumber === undefined) {
        //fieldname is added in record.tsx on each label from getDefaultRow()
        //this ensures we never have objectnumber is undefined
        objectNumber = objectNumberElement.innerHTML
      }

      (clonedElement.querySelectorAll('.pdfOnly') as NodeListOf<HTMLElement>).forEach(el => el.style.display = 'block');
      (clonedElement.querySelectorAll('.screenOnly') as NodeListOf<HTMLElement>).forEach(el => el.style.display = 'none');
      (clonedElement.querySelectorAll('.pdfCenter') as NodeListOf<HTMLElement>).forEach(function(el) {
        el.style.width = '100%'
      });
      (clonedElement.querySelectorAll('.pdfNoBorder') as NodeListOf<HTMLElement>).forEach(function(el) {
        el.style.border = 'none'
      });
      (clonedElement.querySelectorAll('.pdfUnder') as NodeListOf<HTMLElement>).forEach(function(el) {
        el.style.display = 'inline-block'
        el.style.marginLeft = '0px'
        el.style.height = 'auto'
      });

      // Step 3: Send the modified cloned element to html3pdf.
/*      (window as any).html3pdf(clonedElement, {
        margin: 10,
        filename: 'Mdlvw_' + objectNumber + '_Notice.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      });
      document.body.removeChild(clonedElement);
*/

const pdfConfig = {
  margin: 7,
  filename: 'Mdlvw_' + objectNumber + '_Notice.pdf',
  image: { type: 'jpeg', quality: 0.98 },
  html2canvas: { scale: 2, useCORS: true },
  pagebreak: { mode: ['css', 'avoid-all'] },
  jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
  documentProperties: { title: objectNumber }
};



html3pdf().from(clonedElement).set(pdfConfig).toPdf().get('pdf').then((pdfObject:any) => {
  //var number_of_pages = pdfObject.internal.getNumberOfPages()
  var pdf_pages = pdfObject.internal.pages
  var imgData = 'data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAyCAYAAADhna1TAAAABGdBTUEAALGOfPtRkwAAACBjSFJNAACHDwAAjA8AAP1SAACBQAAAfXkAAOmLAAA85QAAGcxzPIV3AAAKNWlDQ1BzUkdCIElFQzYxOTY2LTIuMQAASMedlndUVNcWh8+9d3qhzTDSGXqTLjCA9C4gHQRRGGYGGMoAwwxNbIioQEQREQFFkKCAAaOhSKyIYiEoqGAPSBBQYjCKqKhkRtZKfHl57+Xl98e939pn73P32XuftS4AJE8fLi8FlgIgmSfgB3o401eFR9Cx/QAGeIABpgAwWempvkHuwUAkLzcXerrICfyL3gwBSPy+ZejpT6eD/0/SrFS+AADIX8TmbE46S8T5Ik7KFKSK7TMipsYkihlGiZkvSlDEcmKOW+Sln30W2VHM7GQeW8TinFPZyWwx94h4e4aQI2LER8QFGVxOpohvi1gzSZjMFfFbcWwyh5kOAIoktgs4rHgRm4iYxA8OdBHxcgBwpLgvOOYLFnCyBOJDuaSkZvO5cfECui5Lj25qbc2ge3IykzgCgaE/k5XI5LPpLinJqUxeNgCLZ/4sGXFt6aIiW5paW1oamhmZflGo/7r4NyXu7SK9CvjcM4jW94ftr/xS6gBgzIpqs+sPW8x+ADq2AiB3/w+b5iEAJEV9a7/xxXlo4nmJFwhSbYyNMzMzjbgclpG4oL/rfzr8DX3xPSPxdr+Xh+7KiWUKkwR0cd1YKUkpQj49PZXJ4tAN/zzE/zjwr/NYGsiJ5fA5PFFEqGjKuLw4Ubt5bK6Am8Kjc3n/qYn/MOxPWpxrkSj1nwA1yghI3aAC5Oc+gKIQARJ5UNz13/vmgw8F4psXpjqxOPefBf37rnCJ+JHOjfsc5xIYTGcJ+RmLa+JrCdCAACQBFcgDFaABdIEhMANWwBY4AjewAviBYBAO1gIWiAfJgA8yQS7YDApAEdgF9oJKUAPqQSNoASdABzgNLoDL4Dq4Ce6AB2AEjIPnYAa8AfMQBGEhMkSB5CFVSAsygMwgBmQPuUE+UCAUDkVDcRAPEkK50BaoCCqFKqFaqBH6FjoFXYCuQgPQPWgUmoJ+hd7DCEyCqbAyrA0bwwzYCfaGg+E1cBycBufA+fBOuAKug4/B7fAF+Dp8Bx6Bn8OzCECICA1RQwwRBuKC+CERSCzCRzYghUg5Uoe0IF1IL3ILGUGmkXcoDIqCoqMMUbYoT1QIioVKQ21AFaMqUUdR7age1C3UKGoG9QlNRiuhDdA2aC/0KnQcOhNdgC5HN6Db0JfQd9Dj6DcYDIaG0cFYYTwx4ZgEzDpMMeYAphVzHjOAGcPMYrFYeawB1g7rh2ViBdgC7H7sMew57CB2HPsWR8Sp4sxw7rgIHA+XhyvHNeHO4gZxE7h5vBReC2+D98Oz8dn4Enw9vgt/Az+OnydIE3QIdoRgQgJhM6GC0EK4RHhIeEUkEtWJ1sQAIpe4iVhBPE68QhwlviPJkPRJLqRIkpC0k3SEdJ50j/SKTCZrkx3JEWQBeSe5kXyR/Jj8VoIiYSThJcGW2ChRJdEuMSjxQhIvqSXpJLlWMkeyXPKk5A3JaSm8lLaUixRTaoNUldQpqWGpWWmKtKm0n3SydLF0k/RV6UkZrIy2jJsMWyZf5rDMRZkxCkLRoLhQWJQtlHrKJco4FUPVoXpRE6hF1G+o/dQZWRnZZbKhslmyVbJnZEdoCE2b5kVLopXQTtCGaO+XKC9xWsJZsmNJy5LBJXNyinKOchy5QrlWuTty7+Xp8m7yifK75TvkHymgFPQVAhQyFQ4qXFKYVqQq2iqyFAsVTyjeV4KV9JUCldYpHVbqU5pVVlH2UE5V3q98UXlahabiqJKgUqZyVmVKlaJqr8pVLVM9p/qMLkt3oifRK+g99Bk1JTVPNaFarVq/2ry6jnqIep56q/ojDYIGQyNWo0yjW2NGU1XTVzNXs1nzvhZei6EVr7VPq1drTltHO0x7m3aH9qSOnI6XTo5Os85DXbKug26abp3ubT2MHkMvUe+A3k19WN9CP16/Sv+GAWxgacA1OGAwsBS91Hopb2nd0mFDkqGTYYZhs+GoEc3IxyjPqMPohbGmcYTxbuNe408mFiZJJvUmD0xlTFeY5pl2mf5qpm/GMqsyu21ONnc332jeaf5ymcEyzrKDy+5aUCx8LbZZdFt8tLSy5Fu2WE5ZaVpFW1VbDTOoDH9GMeOKNdra2Xqj9WnrdzaWNgKbEza/2BraJto22U4u11nOWV6/fMxO3Y5pV2s3Yk+3j7Y/ZD/ioObAdKhzeOKo4ch2bHCccNJzSnA65vTC2cSZ79zmPOdi47Le5bwr4urhWuja7ybjFuJW6fbYXd09zr3ZfcbDwmOdx3lPtKe3527PYS9lL5ZXo9fMCqsV61f0eJO8g7wrvZ/46Pvwfbp8Yd8Vvnt8H67UWslb2eEH/Lz89vg98tfxT/P/PgAT4B9QFfA00DQwN7A3iBIUFdQU9CbYObgk+EGIbogwpDtUMjQytDF0Lsw1rDRsZJXxqvWrrocrhHPDOyOwEaERDRGzq91W7109HmkRWRA5tEZnTdaaq2sV1iatPRMlGcWMOhmNjg6Lbor+wPRj1jFnY7xiqmNmWC6sfaznbEd2GXuKY8cp5UzE2sWWxk7G2cXtiZuKd4gvj5/munAruS8TPBNqEuYS/RKPJC4khSW1JuOSo5NP8WR4ibyeFJWUrJSBVIPUgtSRNJu0vWkzfG9+QzqUvia9U0AV/Uz1CXWFW4WjGfYZVRlvM0MzT2ZJZ/Gy+rL1s3dkT+S453y9DrWOta47Vy13c+7oeqf1tRugDTEbujdqbMzfOL7JY9PRzYTNiZt/yDPJK817vSVsS1e+cv6m/LGtHlubCyQK+AXD22y31WxHbedu799hvmP/jk+F7MJrRSZF5UUfilnF174y/ariq4WdsTv7SyxLDu7C7OLtGtrtsPtoqXRpTunYHt897WX0ssKy13uj9l4tX1Zes4+wT7hvpMKnonO/5v5d+z9UxlfeqXKuaq1Wqt5RPXeAfWDwoOPBlhrlmqKa94e4h+7WetS212nXlR/GHM44/LQ+tL73a8bXjQ0KDUUNH4/wjowcDTza02jV2Nik1FTSDDcLm6eORR67+Y3rN50thi21rbTWouPguPD4s2+jvx064X2i+yTjZMt3Wt9Vt1HaCtuh9uz2mY74jpHO8M6BUytOdXfZdrV9b/T9kdNqp6vOyJ4pOUs4m3924VzOudnzqeenL8RdGOuO6n5wcdXF2z0BPf2XvC9duex++WKvU++5K3ZXTl+1uXrqGuNax3XL6+19Fn1tP1j80NZv2d9+w+pG503rm10DywfODjoMXrjleuvyba/b1++svDMwFDJ0dzhyeOQu++7kvaR7L+9n3J9/sOkh+mHhI6lH5Y+VHtf9qPdj64jlyJlR19G+J0FPHoyxxp7/lP7Th/H8p+Sn5ROqE42TZpOnp9ynbj5b/Wz8eerz+emCn6V/rn6h++K7Xxx/6ZtZNTP+kv9y4dfiV/Kvjrxe9rp71n/28ZvkN/NzhW/l3x59x3jX+z7s/cR85gfsh4qPeh+7Pnl/eriQvLDwG/eE8/s6uL5TAAAACXBIWXMAAA7EAAAOxAGVKw4bAAARo0lEQVRoQ81bB2BUVbr+MmlASA8lJEDovRNB2sLCShNRykMEyaICwoMVQRFwFfHBc1nKQ2EVdHkIIgKKKHVBOlHpPZQESCCEJCSk98b7v3/uxEBmTH2rnw4z954zZ+75zt/Pid1DASqIBwnJiImNx8UrYbgedht3oqIRHROvr/yCAtiZ7NC8cQA8PVzRpFE9NAzwR/s2zeBb0xtVq1YxRimOuPhE3LkbI+OG4mZ4lHyORuz9B4iKiYOdtFet4owG9f1Qo4anvPujRZMGaNmsAfx8a8LR0cE8SDlRIWKO/XQWu34IRvDx84i8F4uszCw4yAM52NvD3t4Ek8kEOzs78Cfy8vNRUCDveXnIycmFt5cHGtSrgwH9umHIgN5oFOBnjAr8cOg4vt15EOcvXUdkVAxy8/J1ohzT3mQPk7yTmAIZN5/j5hfIuPn6G95e7mjaKAAD+j6JZwf3gW8tH/OgZUSZieED7BYy/ueTjQi5dkMf2MnRUR+aJPBVIFLChy46tEnuW4gi8nUyeTqZrKwcDB3UG727d8LyVV8iKjpOx3V0IBlChEgcoeMKufyP4F2OV3QB2IdE6ti5eRg9YiBeGjsU7Vo11e+UFmUi5uzFa1j80TrskxWt7lIVTk6Oep/qki8Pky2SkJ2dgyoi4j7e7qjq7Cyt8vjyf0pKuqhcohAGODs7wlm+ywnxRWTJ93Jzc0U9qsDBwV7v6SRlcpZxXau7wMfHQwkjNwXyT2pKGuISkpR4Z2cnXSTzuGai0jNEih1MeGXsc5g9fbz2KQ1KTcySleuxeMV6nRAH5wpRJVR8Pd1R168W+vQMxB9k1Vs3b6TkPI6U1DScPncVh46dwgF5JSenIjEpReyMs0zEXsY09+Mj8eXh7oqmjeurJPXq2hGNG9dTNX0ccQ+SZNGuYu+Bn3DizGXEy3VqWrqSTEmmdGZlZ8szOWHjp/+NLp3aGN+0jRKJSUxOQdCr7+Lk+RC4VKuqK8MfSk5JRYumDfHCiAEY0r8X6vrXNr5ReoRcvYl1m3fiu12HdCIc36JqOSIpY0cOxMK/TtXr0oLTOXk2BBu27MKOvUeRm5OnxHPcXFEvXs+YMgYzp44zvmEdv0pM+O0ojJ4wF7cjo1V1iAwRTU8vN0waNxzTJj6v9yqKJJGcBUv/iS3b9ukEqKJ8qrz8PHTt1Bab1nxg9CwbHoiKvTZ3CY7+eEbVi+PSWFO9Xhg+AMsWzjR6FodNYsLvRGFE0Cx1j2Sc3VJSM0RdOmP1srdVzCsb9EKz5n+IC5dC4ebqYv7NtAwM7Nsd6z6eb/QqO346eRETpv+XLEAKqkl4wHHT0zMxVLzWqqVzjV6PwioxZLTfc68iUuKGaiLe9ERZWdl4a/pLeG1S5UiJLaSlZ2DSzIXYf/A43Nyq670MCQN6deuIrz4rn+QQd6NiMfH1BTh36ZpIfzWVSNq8V8ePwPtzJhu9foH9ewLjcyFG/PlNXLl2UwcgKfQAC96ZiklBw4we/3+guA9/uq+QkY0jEicxiKPrpjQFSNzTpmVjo2fZQJLHjBwk9ucyQm/cQRVxIHQkJ05fRk0JENu1ftSdF5OYv69Yh2X/2CCukaw+lBXMxKJ5ryFo9NNGj5JxK+IuLl29gfj4JI1naE/r1/VFsyYBqOdXeiP96owF+Pr7A6pWybK6f5kwGu/NnmS0lg90/8Nl4U8JQVx42hx61otHN8PDw83o9RgxoTduo8eg8XB1ra7eJyU1HXPE90+fPMboYRshImFfbd2rHiZSUgJHJyeJUulhzF6GD8B4pHGDuhKy18DOTR/p/ZIwa95y7D9yAl6eHti/7RPjbsXR+5mJuBUeqWEFVbVtyybYvWWF0foYMeMmv6MxBjunZ2SiR9cO2PK/i4xW66Cq/WX2Ivxw+ITaB4o+o1VLJEpYXDCvmf+8OGowVix6S++VBhF37mloX9rgrDS4GBKGQf8x1YjJTMgUG0qn8nT/ntpuDjsFB4+ewo49R5QUrm4Nb098vHiO0Wodu/YdQ9PAZ7Bt12GNUimaDNRyJIJlXMIAkAGWhSBe93iyA1b8rfSkELQtlUkK0bZVE8yfO0WkOEdV3UGec/HKdaolRCEx737wCdzEBXN1k6VxYtBwCes9jNbiOCKxwUvT5suk7cwxjnyP9iglNVUi38aYNmEUVi//q0oPieErVSRq8viRFu36zfHymKHy7NV1wZiGnL1wDffjErRNibksyWDojQjJMxzUODHrnfKyTMAGtotkjX5ljkaq9Bj8zkORmKDRQxB2Zgd2bf4Ic2e8Ipa/CmLlh0g2f7xD2+YY/FQPY5TfB9aunKeLRi846rk/ob4RwauNobSs2fCdBj+0LfPenIhJ4t+tgb6/XU9zLEOWqTbMSVaKzejXu4vet6DfsMkIE4NOF5wgOdEXqxZgUL/uRuvvB2fOX0G0BLLMyWgOCBMN5s+nLmrGSjvBOgmTQVuYMH2B6iVJYe7BGOenPWuLkXIz/C5iY+NhL/1ooFlA6tKptdFafhQU5CE/N0tfBfk5hfarIujUviWefqpnISmEKfJuLK7LqnKinEBAPV/NaK3hUPBpnJTslZJFEumBvl23BF5e7kaPX3BOAjLGHiax+EwIe3TpoFl4eVGQn4sHd04hJvQAoq7sxN0rOxB17V+4f+sYMpLvGb0qD6awm7fVVdEOsCby7KA+RlNxrN+0U1WHCRkN7fPD+qNTh5ZG66O4FhoutidfLT5f3QLbGi1lR05mAu5d34eU+BvIzUouLFMV5GUjMyUa98ODkRh1Qe9WFkyXJTBzEjWyGMguna3XKihNO8U9U0ooLfZCzrxZ1qNQVs9OnQ9RY05RZ7DYsX0Lo7VsKMjLQXTYYeTliPTZO8JO6zbmSiHjD5M9n92ExJiLSI69anyr4jCxpEA7wAmwCNSo/i+116I4f/m6lgopLZQsliJtgQRH3YszxzDGPRaoy4MHkWfwMD9bfte8eNbA+/YOVYSYK0JghnG3YjDFxj3Q1Wd5snYt21X7fQd/1goYCeTEf83tMvdISkrWlWTJs5kNm1US8nIzkJ0RJ1JSmoq/qJbYobSEcOO6YjDdlIRPg7CCh3AxilHWEBEZUxisVZcE09+vltFSHOkSE6RlZMkq2ynhdWrXMFrKhpyMBPU+nHRJMEuTHXKzU803KgiVdWNMYdy264uLT1A1IjEuIlW0NbaQLzaGhBBKZBE3WBYwaLTsCJQKnIMYZI0hKgiT1lsIGcvRoTBDKAaG/ZwkoVsYxmdrELNofNJnVU9WLogqFh2rRMgzmeyZU5XhOzZg4s4gyaEopqZTbK3D09NNvRGlhpX9+AcpRktxuLpWg5uoG2sx7B8jUWV5UNW1JhycRNp+ZREsMC+UHZxdvMw3KggTgzPLhO+LutiShC4d22hORAKpJiHXbxgtxcHdQqoP7RYDRwaQ5QFX39nFR55PIuwS1YMFMRNcPMtn6B+HqZ4YUW6H0M5w7+VWRJTR9Cj6/eEJTQVIHIvjGzbvMlqKg4klPRwJJJEZEkCyYl8e+NTvKlJTVewfVd46OQ8fFqhH8q7XWd12ZcDE8J82gBNwdHTUeMUaatX0RsMAP1U75lXnL4ci7OYdo/VRMGls36a5SJh5XCLk+k19Lw9qNf4jnKp4iIfKFinMVyIsLxLyUEjz9u+I6l4NjG9UHKa2rZrKRO3VHrBA/M32/UZTcQSNGqLpA+Hp4YbX316in62BpULmSQS9S/Dx8ofsTlXcUKdFf3jUaQcHZzdRe0bADiodLh51Uaf5ALjVbG70rhyY/GvX1CMUDMQoCdfCInAvJs5ofhRjRw2Gf50aKjWssHMv+635Hxqtj4LZNOMdejDameDjZzW/qgg8fVvDr8UA+DbvD98mfeHfcghqNOgOp2q2C2qlAU9L/HjiAsLv/JKMqvF9olMrVSeG8PfjEvVYhzX4eHlg2sTRSE5J02tm2Wu/3I4PV3+l10XBohTPw+SL6HOj/cz5q7h6/ZbRWjE4OFaFo0hRJXhlxdTZizBm4lz0eWYCfjx+Tu+prD83uI+E8eaAjLXPT9dt1c/WEPT8EPT/45NaG6X9cHOtjoXLPsPI8W/hZkSk0csM9uXmHfuRHB4K+L2BG3DrN+1QoeCJipX/3Kz3lZieT3ZU+0LvRMPJ2ie3LGzh0+XvoHWLRrorQNvq7uoqongez46diSkzP9A9JYK7fB7u1TUcYJH9YPBphIff1bbfC+a8v1K3Zhiu0ERYqguF2yd7fgjGi1Pehae7q3agGpw+tFFLBrbA0mWIkGA5pUD3nCOsU0q4SVbf3xdJqWnIyMjUH6bh7ty+JbZ9sdQY4bfFNzv2Y/rsxbJoVXRnxEscyuGdn+k5nMIcoEe3jmjZvGFhxZxF7MUffm60Wse/tvwDb0wbJ5FtvG5aEczOubvAWCYyOraQFMLZyQmnzoZg07d79fq3BPfiP1i2VubKcgZ00UYN66+kEI9suAWL4Rnx51mFSV98QiI+X/k+nh1su/ZCRETew9KVX+DA0ZN6UJHezcHRXus7lCSqEi0l9Zif796Lxe2Lu1Grhrd5gN8Aw4Pe0FMQ3IrmDmk9/9o4tmuN0foYMcQLYp0PHDmpqkCbw8ns2bICjRvWM3rYBg8CnDwXguOnLuFqWDiuh0ZowZwE8OQmbRKlhkaOpy23f7VccirzCv078XfRhKUfbyg8asJcbv+2VehapHpZjBhOhLaDRpK7f8yP+P7l6gXo3KGV0avs4DGMQaOm6aYbJSkzMxu+tX1w4LvV+oD/Lsye/5F6Xe6GEIyt3pj2ImZOeVGvLSi0MRZQDT5ePNt88lEMEm0F9XHc5Hd1h6C8YGFr6YIZeh6Ya8F86150HIaOfd1mflbZeO9vqx4hhfEYt4oeJ4Wwej6mpo+XSEdLbP3+gF6THBrl9ZI4pmdkoHePznq/rGgU4A8/ibT37A/WuIahAQ8SrvniO63ylffsS0ng4cVBo6bqaVPLSTA6i0DOcd1ivX4cVokhuJHevGkDfL/7sK4wyXFycsDRn8/iuEhObUkq2aes6NC2mXqtTVv3aimVEko7tmPvMVwKCVNbVqtG5dRU6IJXrtmCKTMWqpd1qWbOvHnmr2tgWz2hxQWyhmI25nFcDQ2XqPZNGSytsJxJ40kf1/2Jdpg+ZQwCJTaxuOTS4uLlMAT957u65ctaMpNYqiztWS8JOGdNC5KFCVCvVlZkijRs+Ho3Vn++Vc8QclHplkkUJWVA3+5Yu9KqPBSiRGII6uL0uUv0GLu3p5tOhF+jm0tLy0Bgx1bo2/MJdO/SDgHibXiWhVLwOJiPRdyJFncdg+Cfz+P7PYeVcEtfjsmkk8SzNtRNiP9T767iLVqjrl9t1LZx/J377fybg+s3IrBrH4/wn0NcfJK6YsZkBEnnRN+e+bL5xEUJKBUxFqzduF0PQiclpcLJ2VHVgF/nFiz3nKgafHGT3108jY+3pz5YZlYW4uMTdeeAAR8nwtMFTEJJCsegN9SURFa3KPFcZU6Q0TWDR2bsvjW56/AQqZKvJSQmIz1TxpOxU2WROA7Tm8IxhGQ6EZZXlrw/XVKZ0tmxMhFDcFJMBml7+AcQfFCNHqWNQ1kK5QUsIslngm1UNaoFt1T4zhd/mVVBriYPBzZrHIBDwafUIJNgyylwy5jFxuV4HEvG1PfCcc1qSZICO7TGmJEDMXr4AP1OaVFmYiyIT0jC5m/3YePWPbhxK9Ic5coDcvOOfx1izrH4oGbC+Ct8pwTo1opcZwkpT/XugueHDdTzw4xnIm5H4evt+/HlN3v0z3qKjkvp4sSVar4Z45IsShujav4GieORMZ7SpDqydlRWlJuYogi9eVtyoCs4cfYSbt+JEQ/wQA8Ycw+b6kDRpmvmFoxfHRbG/PT0Q9fANlrjsYWLIaF63PTMhataPLsXGyeSIKohamuu85jHdXerrlvANNaB7VuhV/eOqqYVQaUQUxS0N9R76jalg9d0iSyfsvRQw8fT6Fk2cLwHMi7jKYvUOTqYx60mbtirAkdMigP4P2bJnfT3jXCKAAAAAElFTkSuQmCC'
  for (var i = 1; i < pdf_pages.length; i++) {
      pdfObject.setPage(i)
      pdfObject.setFontSize(7)
      pdfObject.addImage(imgData, 'JPEG', 5, 2, 7, 5)
      pdfObject.text("Catalogue de collections muséales, artistiques et scientifiques en Wallonie - https://www.commoncollections.be/", 15, 5)
      pdfObject.text("page " + i + "/"+ (pdf_pages.length - 1) + " - " +  new Date().toLocaleDateString(), 180, 5)
      //pdfObject.text("Catalogue de collections muséales, artistiques et scientifiques en Wallonie - https://www.commoncollections.be/", 5, 5)
      //pdfObject.text("page " + i + "/"+ (pdf_pages.length - 1) + " - " +  new Date().toLocaleDateString(), 180, 295)
  }
}).save();
//(window as any).worker;
document.body.removeChild(clonedElement);
    });
  }, 1000);

}

const RecordPopup: React.FC<RecordPopupProps> = ({ recordNumber, onClose }) => {
  const { t } = useTranslation();
  const instanceRef = useRef({});
  const { user, cc, setCc, sort, first, setFirst, recordsPerPage, setRecordsPerPage, viewMode, setViewMode, browseMode, setBrowseMode, data, setData } = useCCContext();
  const [selectedRecord, setSelectedRecord] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(recordNumber);
  const [isInput, setIsInput] = useState(false);
  const [inputPage, setInputPage] = useState(currentPage);
  const [sliderPage, setSliderPage] = useState(currentPage); // Local copy for the slider

  const handleClose = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target === e.currentTarget) {
      console.log(viewMode);
      setViewMode('icon');
      onClose();
    }
  };

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPage = parseInt(e.target.value, 10);
    setSliderPage(newPage); // Update the local copy only
  };

  const handleSliderMouseUp = () => {
    updateCurrentPage(sliderPage); // Update the actual value on mouse release
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputPage(parseInt(e.target.value, 10));
  };

  const handleBlur = () => {
    if (inputPage >= 1 && inputPage <= totalRecords) {
      updateCurrentPage(inputPage);
    }
    setIsInput(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleBlur();
    }
  };

  const updateCurrentPage = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const goToPreviousPage = () => updateCurrentPage(Math.max(1, Number(currentPage) - 1));
  const goToNextPage = () => updateCurrentPage(Math.min(totalRecords, Number(currentPage) + 1));
  const goToFirstPage = () => updateCurrentPage(1);
  const goToLastPage = () => updateCurrentPage(Number(totalRecords));

  useEffect(() => {
    const fetchData = async () => {
      const query = generateQuery(cc, user);
      const rangeStart = currentPage;

      const postData = {
        action: "get",
        command: "search",
        query: query,
        fields: "*",
        range: `${rangeStart}-${rangeStart}`,
        sort: ccConfig.sort[sort].field,
        responseformat: "json"
      };

      try {
        const data = await ccUtils.postWithCache(process.env.REACT_APP_BASE_URL as string, postData, instanceRef);
        console.log("payload", data);

        setTotalRecords(data.request.count);
        const records = Array.isArray(data?.records?.record) ? data?.records?.record : [data?.records?.record];
        setSelectedRecord(records[0] ?? null);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [currentPage]);

  function ShareButtons() {

    const invNo = selectedRecord?.data?.record?.uniqid;
    const encodedInvNo = encodeURIComponent(invNo);
    //http://88.99.164.61/pod23/ccExternal.ashx?id=71.1881.21.28.1-11
    const url = `${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}${window.location.pathname}?id=${encodedInvNo}`;
    const recordTitle = selectedRecord?.data?.record?.['objectname'];
    let title = 'Catalogue de collections muséales, artistiques et scientifiques en Wallonie';
    if(recordTitle) {
      title = title + ' - ' + recordTitle;
    }

    return (
      <div className={styles.socialButtons}>
        <div className={styles.socialButtonWrapper}>
          <FacebookShareButton url={url}>
            <FacebookIcon size={31} borderRadius={4} />
          </FacebookShareButton>
        </div>
        <div className={styles.socialButtonWrapper}>
          <TwitterShareButton url={url} title={title}>
            <XIcon size={31} borderRadius={4} />
          </TwitterShareButton>
        </div>
        <div className={styles.socialButtonWrapper}>
          <LinkedinShareButton url={url} title={title}>
            <LinkedinIcon size={31} borderRadius={4} />
          </LinkedinShareButton>
        </div>
        {/*}
        <div className={styles.socialButtonWrapper}>
          <PinterestShareButton url={url} media={url} description={title}>
            <PinterestIcon size={31} borderRadius={4} />
          </PinterestShareButton>
        </div>
        */}
      </div>
    );
  };

  return (
    <div className={styles.popupoverlay} onClick={handleClose}>
      <div className={styles.RecordPopup} >
        <div className={styles.popupheader}>
          <div className={styles.Navigator} >
            <div className={styles.Paginator}>
              <GenericIconButton icon='light/angle-double-left.svg' width='22px' height='20px' onClick={() => goToFirstPage()} />
              <GenericIconButton icon='light/angle-left.svg' width='22px' height='20px' onClick={() => goToPreviousPage()} />
              <GenericIconButton icon='light/angle-right.svg' width='22px' height='20px' onClick={() => goToNextPage()} />
              <GenericIconButton icon='light/angle-double-right.svg' width='22px' height='20px' onClick={() => goToLastPage()} />
            </div>
            <div className={styles.CurPage}>
              {t("curpage_page")}&nbsp;
              {isInput ? (
                <input
                  type="number"
                  value={inputPage}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  onKeyDown={handleKeyPress}
                  style={{ width: '50px' }}
                  autoFocus
                />
              ) : (
                <span onClick={() => { setIsInput(true); setInputPage(currentPage); }}>{currentPage.toLocaleString()}</span>
              )}&nbsp;{t("curpage_of")} {Number(totalRecords).toLocaleString()}
            </div>
            <div className={styles.ResultSetSlider}>
              <input
                type="range"
                min="1"
                max={totalRecords}
                value={sliderPage} // Use the local copy for rendering
                onChange={handleSliderChange}
                onMouseUp={handleSliderMouseUp} // Handle mouse release
                onTouchEnd={handleSliderMouseUp}
                style={{ width: '100%' }}
              />
            </div>
          </div>
          <div className={styles.closeButtonContainer}>
            <div className={styles.socials}>
              {ShareButtons()}
            </div>
            <div className={styles.generatePdfButton}>
              <button className={genericStyles.GenericButton} onClick={() => generatePdf(selectedRecord?.data?.record?.objectnumber)}>{t("record_generate_pdf")}</button>
            </div>
            <div className={styles.closeButton}>
              <GenericIconButton icon='light/times.svg' width='18px' height='18px' onClick={() => onClose()} />
            </div>
          </div>
        </div>
        <div className={styles.popupcontent}>
          {isLoading ? (
            <div>Loading...</div>
          ) : (
            <Record record={selectedRecord} />
          )}
        </div>
      </div>
    </div>
  );
};

export default RecordPopup;
